import factory from './factory';

export default {
    __init__ : [
        'elementFactory'
    ],
    elementFactory: ['type', factory]
};